import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@atlas/ui';

const StoreAccordion = ({ children, defaultExpanded = true, title }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const toggle = () => setIsExpanded(prev => !prev);

  const arrowIconName = isExpanded ? 'arrow-up' : 'arrow-down';

  return (
    <div className="store-accordion">
      <button className="store-accordion__header" onClick={toggle} type="button">
        <span className="store-accordion__title">{title}</span>
        <Icon className="store-accordion__arrow" name={arrowIconName} />
      </button>

      {isExpanded && <div className="store-accordion__content">{children}</div>}
    </div>
  );
};

StoreAccordion.propTypes = {
  children: PropTypes.node,
  defaultExpanded: PropTypes.bool,
  title: PropTypes.node.isRequired,
};

export default StoreAccordion;
